import { tsValidateArray, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { dpViewTypes } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    type: tsValidateValue([...dpViewTypes]),
    enforcedTags: tsValidateArray(tsValidateUniqueId),
    filter: {
        tagIds: {
            whitelist: tsValidateArray(tsValidateUniqueId, false),
            blacklist: tsValidateArray(tsValidateUniqueId, false),
        },
    },
};
const Validator_GeneratedProps = {};
export const DBDef_DiseaseView = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1'],
    dbKey: 'disease-profile-view-configs',
    entityName: 'DiseaseView',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'disease-view'
    },
    backend: {
        name: 'disease-profile-view-configs'
    },
    dependencies: {
        'enforcedTags': {
            dbKey: 'tags',
            fieldType: 'string[]'
        },
        'filter.tagIds.blacklist': {
            dbKey: 'tags',
            fieldType: 'string[]'
        },
        'filter.tagIds.whitelist': {
            dbKey: 'tags',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map